import { IdentifyClarityProps } from "./clarity.types";

type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    clarity: ClarityFn;
  }
}

const initialize = () => {
  if (!window.clarity) {
    const clarity: ClarityFn = (...args: unknown[]) => {
      clarity.q = clarity.q || [];
      clarity.q.push(args);
    };
    window.clarity = clarity;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${import.meta.env.VITE_CLARITY_ID}`;
  const firstScript = document.getElementsByTagName("script")[0];
  firstScript?.parentNode?.insertBefore(script, firstScript);
};

const identifyClarity: IdentifyClarityProps = ({
  userId,
  email,
}: {
  userId: string;
  email: string;
}) => {
  window.clarity("identify", userId, email);
};

export const clarityService = { initialize, identifyClarity };
